// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__3rO_v"};